<script>
export default {
  data() {
    return {
      data: []
    }
  },
  mounted() {
    this.data = []
    this.init()
    this.$validate.ToDocumentTitle()
  },
  methods: {
    init() {
      this.$axios.get('/laboratory/click_logs/queryClickLogs').then((res) => {
        this.data = res.data.data
      })
    }
  }
}
</script>
<template>
  <div class="assay-statistic-container">
    <template v-for="item in data">
      <el-row :gutter="20" style="margin-top: 10px;">
        <el-col :span="24">
          <div class="statistic-title">
            {{ item.title }}统计
          </div>
        </el-col>
        <el-col :span="6" v-for="(value, key) in item.data" :key="key">
          <el-card style="width: 100%; margin-bottom: 18px;" shadow="never">
            <el-statistic :title="key" :value="value">
              <template #prefix>
                <i class="el-icon-user" style="vertical-align: -0.125em; margin-right: 0.1em;"></i>
              </template>
            </el-statistic>
          </el-card>
        </el-col>
      </el-row>
    </template>
  </div>
</template>
<style lang="scss" scoped>
.assay-statistic-container {
  height: 100%;
  width: 100%;
  background-color: #f3f8fc;
  padding: 10px;
  box-sizing: border-box;
  overflow: auto;

  .statistic-title {
    font-size: 20px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    border-bottom: 1px solid #ccc8c8;
    margin-bottom: 18px;
  }
}
</style>